export const theme = {
  // primaryFontFamily: "Montserrat",
  primaryFontFamily: "Montserrat",
  redLabelColor: "#B0313A",
  dayLabelColor: "#848484",
  // mainIndicationColor: "#E21824",
  mainIndicationColor: "#25d4cf",
  blackColorLabel: "#333333",
  primary: "#2FD4CF",
}
